import {useShoppingCart} from "./useShoppingCart";
import {useQuery} from "@tanstack/react-query";
import {useCountryLang} from "./useCountryLang";
import {ICartItem, toAppShopCartProduct} from "../interfaces/ICartItem";
import {request} from "../shared/httpInterceptor";
import {useContext, useEffect, useState} from "react";
import {IOrderCosts} from "../interfaces/IOrderCosts";
import {useUserLoggedIn} from "./useUserLoggedIn";
import {LoggedOutCartContext} from "../contexts/LoggedOutCartContext";

export const fetchShippingCostsForCart = async (countryLang: string | null, cartProducts: any[]) => {
  // Filter out any invalid products that don't have productId
  const validProducts = cartProducts.filter(product =>
    product &&
    product.shopProductQuantity &&
    product.shopProductQuantity.productID
  );

  const body = {
    products: validProducts,
  };

  const res = await request({
    url: `/${countryLang}/shippingCosts`,
    data: body,
    method: 'post',
  });
  return res.data;
};

export const useShippingCosts = () => {
  const shoppingCart = useShoppingCart()
  const countryLang = useCountryLang()
  const [cartProducts, setCartProducts] = useState<any[]>([])
  const [cartTotalProductsCount, setCartTotalProductsCount] = useState<number | null>(null)
  const isUserLoggedIn = useUserLoggedIn();
  const {loggedOutCartCtx} = useContext(LoggedOutCartContext);

  useEffect(() => {
    // logged-in cart
    if (isUserLoggedIn && shoppingCart.data && shoppingCart.data.products && shoppingCart.data.products.length>0) {
      const cartItems = shoppingCart.data.products
        .filter((item: ICartItem) => item && item.product && item.product.productID) // Ensure valid products only
        .map((item: ICartItem) => {
          return toAppShopCartProduct(item);
        })

      const count = cartItems.map(item => item.shopProductQuantity.quantity)
        .reduce((a, b) => a + b, 0)
      setCartTotalProductsCount(count)
      setCartProducts(cartItems)
    }

    // logged-out cart
    if (!isUserLoggedIn && loggedOutCartCtx != null && loggedOutCartCtx.length > 0) {
      const cartItems = loggedOutCartCtx
        ?.filter((item: any) => item && item.product && item.product.productID) // Ensure valid products only
        .map((item: any) => {
          return toAppShopCartProduct(item);
        })

      const count = cartItems.map(item => item.shopProductQuantity.quantity)
        .reduce((a, b) => a + b, 0)
      setCartTotalProductsCount(count)
      setCartProducts(cartItems)
    }
  }, [shoppingCart.data, isUserLoggedIn, loggedOutCartCtx])


  return useQuery<IOrderCosts>(["shipping-costs", countryLang, cartTotalProductsCount],
    () => fetchShippingCostsForCart(countryLang, cartProducts), {
      enabled: countryLang != null && cartProducts.length > 0
    })
}